/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityReportStatusResource } from './';
import {
    ActivityReportStatusResourceFromJSON,
    ActivityReportStatusResourceFromJSONTyped,
    ActivityReportStatusResourceToJSON,
} from './';
import type { DetailedActivityReportResource } from './';
import {
    DetailedActivityReportResourceFromJSON,
    DetailedActivityReportResourceFromJSONTyped,
    DetailedActivityReportResourceToJSON,
} from './';
import type { PaymentMethod } from './';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
} from './';
import type { ReportTypeResource } from './';
import {
    ReportTypeResourceFromJSON,
    ReportTypeResourceFromJSONTyped,
    ReportTypeResourceToJSON,
} from './';
import type { SimpleActivityReportResource } from './';
import {
    SimpleActivityReportResourceFromJSON,
    SimpleActivityReportResourceFromJSONTyped,
    SimpleActivityReportResourceToJSON,
} from './';
import type { TemporalUnitResource } from './';
import {
    TemporalUnitResourceFromJSON,
    TemporalUnitResourceFromJSONTyped,
    TemporalUnitResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ActivityReportResource
 */
export interface ActivityReportResource {
    /**
     * 
     * @type {string}
     * @memberof ActivityReportResource
     */
    activityReportId: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReportResource
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReportResource
     */
    projectLotId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActivityReportResource
     */
    projectLotIsTheFinalLot: boolean;
    /**
     * 
     * @type {string}
     * @memberof ActivityReportResource
     */
    projectSubject: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportResource
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportResource
     */
    month: number;
    /**
     * 
     * @type {Date}
     * @memberof ActivityReportResource
     */
    projectStartDate: Date;
    /**
     * 
     * @type {TemporalUnitResource}
     * @memberof ActivityReportResource
     */
    unit: TemporalUnitResource;
    /**
     * 
     * @type {ActivityReportStatusResource}
     * @memberof ActivityReportResource
     */
    status: ActivityReportStatusResource;
    /**
     * 
     * @type {ReportTypeResource}
     * @memberof ActivityReportResource
     */
    reportType: ReportTypeResource;
    /**
     * Total of work amounts for this activity report
     * @type {number}
     * @memberof ActivityReportResource
     */
    totalWorkAmount: number;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof ActivityReportResource
     */
    paymentMethod: PaymentMethod;
    /**
     * Estimated work amounts for this activity report
     * @type {number}
     * @memberof ActivityReportResource
     */
    estimatedWorkAmount: number;
    /**
     * Freelancer's last submission to client date of the activity report
     * @type {Date}
     * @memberof ActivityReportResource
     */
    lastFreelancerSubmissionDate?: Date;
    /**
     * Free text informed by the freelancer to explain the work did for that activity report
     * @type {string}
     * @memberof ActivityReportResource
     */
    workDescription?: string;
}

/**
 * Check if a given object implements the ActivityReportResource interface.
 */
export function instanceOfActivityReportResource(value: object): value is ActivityReportResource {
    if (!('activityReportId' in value) || value['activityReportId'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('projectLotId' in value) || value['projectLotId'] === undefined) return false;
    if (!('projectLotIsTheFinalLot' in value) || value['projectLotIsTheFinalLot'] === undefined) return false;
    if (!('projectSubject' in value) || value['projectSubject'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('projectStartDate' in value) || value['projectStartDate'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('reportType' in value) || value['reportType'] === undefined) return false;
    if (!('totalWorkAmount' in value) || value['totalWorkAmount'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('estimatedWorkAmount' in value) || value['estimatedWorkAmount'] === undefined) return false;
    return true;
}

export function ActivityReportResourceFromJSON(json: any): ActivityReportResource {
    return ActivityReportResourceFromJSONTyped(json, false);
}

export function ActivityReportResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityReportResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['reportType'] === 'DETAILED') {
            return DetailedActivityReportResourceFromJSONTyped(json, true);
        }
        if (json['reportType'] === 'SIMPLE') {
            return SimpleActivityReportResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'activityReportId': json['activityReportId'],
        'projectId': json['projectId'],
        'projectLotId': json['projectLotId'],
        'projectLotIsTheFinalLot': json['projectLotIsTheFinalLot'],
        'projectSubject': json['projectSubject'],
        'year': json['year'],
        'month': json['month'],
        'projectStartDate': (new Date(json['projectStartDate'])),
        'unit': TemporalUnitResourceFromJSON(json['unit']),
        'status': ActivityReportStatusResourceFromJSON(json['status']),
        'reportType': ReportTypeResourceFromJSON(json['reportType']),
        'totalWorkAmount': json['totalWorkAmount'],
        'paymentMethod': PaymentMethodFromJSON(json['paymentMethod']),
        'estimatedWorkAmount': json['estimatedWorkAmount'],
        'lastFreelancerSubmissionDate': json['lastFreelancerSubmissionDate'] == null ? undefined : (new Date(json['lastFreelancerSubmissionDate'])),
        'workDescription': json['workDescription'] == null ? undefined : json['workDescription'],
    };
}

export function ActivityReportResourceToJSON(value?: ActivityReportResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.reportType === 'DETAILED') {
            return DetailedActivityReportResourceToJSON(value as DetailedActivityReportResource);
        }
        if (value.reportType === 'SIMPLE') {
            return SimpleActivityReportResourceToJSON(value as SimpleActivityReportResource);
        }
    }
    return {
        
        'activityReportId': value['activityReportId'],
        'projectId': value['projectId'],
        'projectLotId': value['projectLotId'],
        'projectLotIsTheFinalLot': value['projectLotIsTheFinalLot'],
        'projectSubject': value['projectSubject'],
        'year': value['year'],
        'month': value['month'],
        'projectStartDate': ((value['projectStartDate']).toISOString().substring(0,10)),
        'unit': TemporalUnitResourceToJSON(value['unit']),
        'status': ActivityReportStatusResourceToJSON(value['status']),
        'reportType': ReportTypeResourceToJSON(value['reportType']),
        'totalWorkAmount': value['totalWorkAmount'],
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'estimatedWorkAmount': value['estimatedWorkAmount'],
        'lastFreelancerSubmissionDate': value['lastFreelancerSubmissionDate'] == null ? undefined : ((value['lastFreelancerSubmissionDate']).toISOString().substring(0,10)),
        'workDescription': value['workDescription'],
    };
}

